<div class="regulation-bd-container">
  <h1 class="page-title">法規資料庫</h1>

  <!-- 顯示模式切換 -->
  <div class="display-mode-toggle">
    <button
      [class.active]="displayMode === 'directory'"
      (click)="changeDisplayMode('directory')"
    >
      依法規目錄顯示
    </button>
    <!-- <button
      [class.active]="displayMode === 'timeline'"
      (click)="changeDisplayMode('timeline')"
    >
      依變更時間顯示
    </button> -->
  </div>

  <!-- 載入中提示 -->
  <div class="loading-indicator" *ngIf="isLoading">
    <span>載入資料中...</span>
  </div>

  <!-- 主要內容區域 -->
  <div class="main-content" *ngIf="!isLoading">

    <!-- 時間軸模式的部門選擇器 (現在位於頂部) -->
    <div class="department-selector-top" *ngIf="displayMode === 'timeline'">
      <h3>選擇法規資料庫</h3>
      <div class="department-checkbox-list">
        <div
          *ngFor="let dept of initialDepartments"
          class="department-checkbox"
          [class.selected]="isDepartmentSelected(dept)"
          (click)="toggleDepartmentSelection(dept)"
        >
          <span class="checkbox">
            <span class="checkmark" *ngIf="isDepartmentSelected(dept)">✓</span>
          </span>
          <span class="dept-name">{{dept}}</span>
        </div>
      </div>
    </div>

    <!-- 目錄模式的部門選擇器 (現在位於頂部) -->
    <div class="department-selector-top" *ngIf="displayMode === 'directory'">
      <h3>選擇法規資料庫</h3>
      <div class="department-button-list">
        <button
          *ngFor="let dept of initialDepartments"
          class="department-button"
          [class.selected]="selectedDepartment === dept"
          (click)="selectDepartment(dept)"
        >
          {{dept}}
        </button>
      </div>

      <!-- 新增搜尋區域 -->
      <div class="search-filters" *ngIf="selectedDepartment">
        <div class="search-container">
          <div class="keyword-search">
            <label for="keyword">法規關鍵字搜尋：</label>
            <div class="search-input-container">
              <input
                type="text"
                id="keyword"
                name="keyword"
                [(ngModel)]="searchKeyword"
                placeholder="請輸入法規名稱或關鍵字"
              >
            </div>
          </div>

          <div class="date-range">
            <div class="date-range-header">
              <label>法規異動時間區間：</label>
              <div class="quick-date-buttons">
                <button class="quick-date-btn" (click)="setDateRangeForCurrentMonth()">本月</button>
                <button class="quick-date-btn" (click)="setDateRangeForLastMonth()">上個月</button>
                <button class="quick-date-btn" (click)="setDateRangeForLastThreeMonths()">近三個月</button>
              </div>
            </div>
            <div class="date-inputs">
              <input
                type="date"
                [(ngModel)]="searchStartDate"
                name="startDate"
                placeholder="開始日期"
              >
              <span class="date-separator">至</span>
              <input
                type="date"
                [(ngModel)]="searchEndDate"
                name="endDate"
                placeholder="結束日期"
              >
              <button class="search-button" (click)="applySearch()">搜尋</button>
              <button class="clear-button" (click)="clearSearch()" *ngIf="isSearchActive">清除</button>
            </div>
          </div>

          <!-- 搜尋提示 -->
          <div class="search-status" *ngIf="isSearchActive">
            <span class="search-active-badge">搜尋中</span>
            <span class="search-criteria">
              <span *ngIf="searchKeyword">關鍵字: {{searchKeyword}}</span>
              <span *ngIf="searchKeyword && (searchStartDate || searchEndDate)"> | </span>
              <span *ngIf="searchStartDate || searchEndDate">
                日期: {{searchStartDate | date:'yyyy-MM-dd'}} 至 {{searchEndDate | date:'yyyy-MM-dd'}}
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- 下方內容區域 (分成左右兩側) -->
    <div class="content-split-view">
      <!-- 左側：時間軸或目錄 -->
      <div class="left-panel">
        <!-- 時間軸導航 -->
        <div class="timeline-navigator" *ngIf="displayMode === 'timeline'">
          <h3>法規變更時間</h3>
          <div class="timeline-tree">
            <div *ngFor="let yearNode of timelineData" class="year-node">
              <div class="year-label">{{yearNode.year}}</div>
              <div class="month-list">
                <div
                  *ngFor="let monthNode of yearNode.months"
                  class="month-node"
                  [class.selected]="selectedYearMonth?.year === yearNode.year && selectedYearMonth?.month === monthNode.month"
                  (click)="selectYearMonth(yearNode.year, monthNode.month)"
                >
                  <span class="month-label">{{formatMonth(monthNode.month)}}月</span>
                  <span class="law-count" *ngIf="getLawCount(yearNode.year, monthNode.month) > 0">
                    ({{getLawCount(yearNode.year, monthNode.month)}})
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 分類瀏覽 -->
        <div class="type-selector" *ngIf="displayMode === 'directory' && selectedDepartment">
          <h3>{{ isSearchActive ? '搜尋結果分類' : '分類' }}</h3>

          <!-- 搜尋結果為空時顯示提示 -->
          <div *ngIf="isSearchActive && searchResultCategories.length === 0" class="no-results-message">
            沒有符合搜尋條件的法規
          </div>

          <!-- 雙層分類結構 -->
          <div class="category-list" *ngIf="getDepartmentCategoriesForSelected().length > 0">
            <!-- 母階層（DepartName）-->
            <div *ngFor="let parent of getDepartmentCategoriesForSelected()" class="parent-category-item">
              <div
                class="parent-category-header"
                [class.expanded]="parent.expanded"
                (click)="toggleParentCategory(parent)"
              >
                <span class="expand-icon">{{ parent.expanded ? '▼' : '►' }}</span>
                <span class="parent-name">{{ parent.name }}</span>
                <span class="law-count">({{ getParentCategoryLawCount(parent.name) }})</span>
              </div>

              <!-- 子階層列表（type）-->
              <div class="type-sublist" *ngIf="parent.expanded">
                <div
                  *ngFor="let type of parent.types"
                  class="type-item"
                  [class.selected]="selectedParentCategory === parent.name && selectedType === type"
                  (click)="selectTypeWithParent(parent.name, type)"
                >
                  <span class="type-name">{{ type }}</span>
                  <span class="law-count">({{ getTypeLawCount(parent.name, type) }})</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 右側：法規列表 -->
      <div class="right-panel">
        <h3 *ngIf="displayMode === 'timeline' && selectedYearMonth">
          {{selectedYearMonth.year}}年{{formatMonth(selectedYearMonth.month)}}月法規變更
        </h3>
        <h3 *ngIf="displayMode === 'directory' && selectedDepartment && selectedType">
          {{selectedDepartment}} - {{selectedType}}
        </h3>

        <div class="no-laws-message" *ngIf="displayedLaws.length === 0">
          沒有找到符合條件的法規
        </div>

        <table class="law-table" *ngIf="displayedLaws.length > 0">
          <thead>
            <tr>
              <th>法規名稱</th>
              <th>更新日期</th>
              <!-- 新增詳細內容欄位 -->
              <th>詳細內容</th>
              <th *ngIf="shouldShowDepartmentColumn()">部門</th>
              <th *ngIf="hasAnyLawWithStatus()">狀態</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let law of displayedLaws" >
              <td class="law-name" (click)="openLawUrl(law.lawUrl)">{{law.lawName}}  (共{{law.lawArticlesCount}}條)
              </td>
              <td>{{law.date}}</td>
              <!-- 新的詳細內容欄位，添加點擊事件開啟彈出視窗 -->
              <td>
                <!-- 修改條件：只要有 lawArticlesCount > 0 就顯示檢視按鈕 -->
                <span *ngIf="law.lawArticlesCount > 0"
                      class="view-details-link"
                      (click)="fetchLawDetails(law); $event.stopPropagation()">檢視</span>
              </td>
              <td *ngIf="shouldShowDepartmentColumn()">{{getDepartmentName(law)}}</td>
              <td *ngIf="hasAnyLawWithStatus()" class="law-status">
                <span *ngIf="law.status" class="status-badge">{{law.status}}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<!-- 法規詳細內容彈出視窗 -->
<div class="popup fullscreen" *ngIf="selectedLawDetails">
  <div class="popup-content">
    <!-- 關閉按鈕 -->
    <button class="close-btn" (click)="closeLawDetailsModal()">關閉</button>

    <!-- 法規相關資訊 -->
    <div class="law-info">
      <h2>{{ selectedLawDetails.lawName }}</h2>
      <p><strong>更新日期:</strong> {{ selectedLawDetails.date }}</p>
      <p><strong>法規編號:</strong> {{ selectedLawDetails.laws?.law_key || '無' }}</p>
      <p><strong>分類:</strong> {{ selectedLawDetails.laws?.law_category || '未分類' }}</p>
      <a [href]="selectedLawDetails.lawUrl" target="_blank" class="law-source-link">查看原文</a>
    </div>

    <!-- 法條內容 -->
    <h3>法條內容</h3>
    <ng-container *ngIf="selectedLawDetails.laws">
      <div *ngIf="selectedLawDetails.laws.law_articles && selectedLawDetails.laws.law_articles.length > 0; else noArticles">
        <div *ngFor="let article of selectedLawDetails.laws.law_articles" class="article-item">
          <!-- 顯示章節標題 -->
          <div *ngIf="article.article_type === 'C'" class="chapter-title">
            <h4>{{ article.article_content }}</h4>
          </div>

          <!-- 顯示條文 -->
          <div *ngIf="article.article_type === 'A'" class="article-content">
            <p><strong>{{ article.article_no }}</strong></p>
            <p [innerHTML]="formatArticleContent(article.article_content)"></p>
            <hr />
          </div>
        </div>
      </div>
    </ng-container>
    <ng-template #noArticles>
      <p>無法條內容</p>
    </ng-template>
  </div>
</div>
